
/*

Render Frame

Global ticker for window.requestAnimationFrame();

Add / remove subscribers.
Very simple - objective is to remove requestAnimationFrame stacking.

// METHODS:
// on(callback, context, recurring, frameDelay){ }
// subscribe to frame trigger(s)

// - callback: callback method (required)
// - context: callback context (optional)
// - recurring: continue listening every frame (optional, default: true)
// - frameDelay: trigger after X frames (optiona, default: 1)

// one(callback, context, frameDelay){ }
// subscribe to only one frame trigger

// - callback: callback method (required)
// - context: callback context (optional)
// - frameDelay: trigger after X frames (optiona, default: 1)

// off(callback, context){ }
// remove listener

// - callback: callback method (required)
// - context: callback context (optional)

Last edited 04.13.17 by David Robbins

*/

class AnimationFrame {

	constructor(){

		this.animationFrame;
		this.frameCount = 0;
		this.subscribers;
		this._init();
	}

	_init(){
		this._tick();
	}

	// public methods

	on(callback, context, recurring, frameDelay){
		this._addListener(callback, context, recurring, frameDelay);
	}

	one(callback, context, frameDelay){
		this._addListener(callback, context, false, frameDelay);
	}

	off(callback, context){
		this._removeListener(callback, context);
	}

	// private methods

	_addListener(callback, context, recurring, frameDelay){

		if(typeof(context) === 'undefined'){ context = null; }
		if(typeof(recurring) === 'undefined'){ recurring = true; }
		if(typeof(frameDelay) === 'undefined'){ frameDelay = 1; }

		//

		if(!this.subscribers){ this.subscribers = []; }

		let match = false;
		for(let i=0, len=this.subscribers.length; i<len; i++){

			let subscriber = this.subscribers[i];

			if(subscriber.callback === callback
				&& subscriber.context === context
				&& subscriber.recurring === recurring
				&& subscriber.frameDelay === frameDelay){

				match = true;
				break;
			}
		}

		if(!match){
			this.subscribers.push({
				callback: callback,
				context: context,
				recurring: recurring,
				frameDelay: frameDelay,
				startFrame: this.frameCount
			});
		}

		// console.log('_addListener', this.subscribers);
	}

	_removeListener(callback, context, recurring, frameDelay){

		if(typeof(context) === 'undefined'){ context = null; }
		if(typeof(recurring) === 'undefined'){ recurring = true; }
		if(typeof(frameDelay) === 'undefined'){ frameDelay = 1; }

		//

		if(!this.subscribers){ this.subscribers = []; }

		for(let i=0, len=this.subscribers.length; i<len; i++){

			let subscriber = this.subscribers[i];

			if(subscriber.callback === callback
				&& subscriber.context === context
				&& subscriber.recurring === recurring
				&& subscriber.frameDelay === frameDelay){

				this.subscribers.splice(i, 1);
				break;
			}
		}
	}

	_triggerFrame(){

		if(this.subscribers && this.subscribers.length){

			// console.log('_triggerFrame b', this.subscribers);

			for(let i=0, len=this.subscribers.length; i<len; i++){

				let subscriber = this.subscribers[i];
				let frameAge = this.frameCount - subscriber.startFrame;

				if(subscriber.frameDelay === 1 || frameAge % subscriber.frameDelay === 0){
					subscriber.callback.apply(subscriber.context, []);
					if(!subscriber.recurring){
						this.subscribers.splice(i,1);
						len--;
						i--;
					}
				}
			}

			// console.log('_triggerFrame a', this.subscribers);
		}
	}

	// ticker

	_tick(){
		this.frameCount ++;
		this.animationFrame = window.requestAnimationFrame(() => {
			this._triggerFrame();
			this._tick();
		});
	}
}

module.exports = AnimationFrame;
